import React from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Submenu from '../common/subMenu/';
import { useDispatch } from 'react-redux';
import './style.scss';
import {userCanAccess, userHasOneDistrict} from "../../utils/users";
import {clearAllUserAlerts} from "../../actions/users";
import {clearActiveReport} from "../../actions/reports";
import {clearFilesUploaded} from "../../actions/uploads";
import {checkIfLoggedInOrTermsAndConditions} from "../../utils/session";

const AUTHENTICATED_LINKS = [
  {
    label: 'My users',
    url: '/users',
    needsDistrict: true,
    permission: 'users'
  },
  {
    label: 'My data',
    url: '/my-data',
    needsDistrict: true,
    permission: '/my-data'
  },
  {
    label: 'My reports',
    url: '/reports-gallery',
    needsDistrict: true,
    'permission': '/reports-gallery'
  }
];

const UNAUTHENTICATED_LINKS = [
];

const Navigation = () => {
  const location = useLocation();
  const { pathname } = location;
  const user = useSelector((state) => state.session.currentUser);
  const userComposite = useSelector((state) => state.session.currentUserComposite);
  const loggedIn = useSelector((state) => state.session.loggedIn);
  const mustAcceptTermsAndConditions = useSelector((state) => state.session.mustAcceptTermsUser);
  const currentDistrict = useSelector((state) => state.districts.currentDistrict);
  const isLoading = useSelector((state) => state.session.isLoading);

  const links = checkIfLoggedInOrTermsAndConditions(mustAcceptTermsAndConditions, loggedIn) ? AUTHENTICATED_LINKS : UNAUTHENTICATED_LINKS;

  const dispatch = useDispatch();

  const submenuItems = [
    { label: 'My Profile', path: '/my-profile', needsDistrict: true },
    { label: 'Switch Districts', path: '/switch-districts', needsDistrict: true, needsMultipleDistricts: true, permission: '/switch-districts' },
    { label: 'Manage Schools', path: '/manage-schools', needsDistrict: true, permission: 'manage-schools' },
    { label: 'Status Report', path: '/status-reports', needsDistrict: true, permission: '/status-reports' },
    { label: 'Logout', path: '/logout', needsDistrict: false , alwaysShow: true}
  ];

  const submenuCanAccess = (item) => {
    return (item.alwaysShow || (districtConditional(item) && userCanAccess(userComposite, item.permission)));
  }

  const districtConditional = (item) => {
    return (item.needsDistrict === false) || (currentDistrict);
  }

  function clearAlerts() {
    dispatch(clearAllUserAlerts());
    dispatch(clearFilesUploaded());
    dispatch(clearActiveReport());
  }

  function getUserName() {
    return (mustAcceptTermsAndConditions) ? mustAcceptTermsAndConditions.username : user.username;
  }

  return (isLoading) ? '' : (
    <nav className='main-navigation' aria-label='Main navigation'>
      <ul>
        {links.map((link, index) => {
          const isCurrent = pathname === link.url;
          return (districtConditional(link) && userCanAccess(userComposite, link.permission)) ? (
            <li key={index} className={isCurrent ? 'current' : ''} aria-current={isCurrent ? 'page' : undefined}>
              {isCurrent ? (
                <span>{link.label}</span>
              ) : (
                <Link to={link.url} onClick={() => clearAlerts()}>{link.label}</Link>
              )}
            </li>
          ) : '';
        })}
        {checkIfLoggedInOrTermsAndConditions(mustAcceptTermsAndConditions, loggedIn) && (
          <li>
            <Submenu triggerContent={<span>{getUserName()}</span>} items={submenuItems} conditional={submenuCanAccess} userComposite={userComposite}/>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Navigation;
